import { useQuery } from "react-query";
import http from "shared/http";
import { GridFetchResponse } from "shared/types";
import { CPGridV2Filters } from "shared/components/shared/CPGridV2/types";
import { driver } from "localforage";

export interface DriverSettlementSearchParams extends CPGridV2Filters {
  driver?: string;
  orderNumber?: string;
  beginDate?: string;
  endDate?: string;
}

export interface AgentSettlementSearchParams extends CPGridV2Filters {
  agency?: string;
  orderNumber?: string;
  beginDate?: string;
  endDate?: string;
}

export interface DriverSettlementRecord {
  payDate: string;
  imageName: string;
  volID: string;
  pdfBytes: string;
  pageCount: number;
  settlementPay: number;
  payeeID: string;
  driverID: string;
  error: string;
}

export interface AgentSettlementRecord {
  payDate: string;
  imageName: string;
  volID: string;
  pdfBytes: string;
  pageCount: number;
  settlementPay: number;
  payeeID: string;
  driverID: string;
  error: string;
}

export const useSearchDriverSettlementsQuery = (
  params: DriverSettlementSearchParams,
) => {
  return useQuery(
    ["driver-settlements", JSON.stringify(params)],
    async () => {
      const response: GridFetchResponse = await http.fetchAsync(
        "settlements/driver/search",
        params,
      );
      return response;
    },
    {
      staleTime: 30 * 1000,
    },
  );
};

export const useSearchAgentSettlementsQuery = (
  params: AgentSettlementSearchParams,
) => {
  return useQuery(
    ["agent-settlements", JSON.stringify(params)],
    async () => {
      const response: GridFetchResponse = await http.fetchAsync(
        "settlements/agency/search",
        params,
      );
      return response;
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
};

export const fetchDriverSettlementPdf = async (
  record: DriverSettlementRecord,
): Promise<DriverSettlementRecord> => {
  const result: DriverSettlementRecord = await http.fetchAsync(
    "settlements/driver/download",
    {
      driver: record.driverID,
      requestdate: record.payDate,
      imagename: record.imageName,
    },
  );
  return result;
};

export const fetchAgentSettlementPdf = async (
  record: AgentSettlementRecord,
  agency: string,
): Promise<AgentSettlementRecord> => {
  const result: AgentSettlementRecord = await http.fetchAsync(
    "settlements/agency/download",
    {
      agency,
      requestdate: record.payDate,
      imagename: record.imageName,
    },
  );
  return result;
};
